import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class FormDataService {
  private subject = new Subject<Object>();

  constructor() { }

  sendData(data) {
    this.subject.next(data);
  }

  getData(): Observable<Object> {
    return this.subject.asObservable();
  }

  clearData() {
    this.subject.next();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared-services/form-data.service.ts